module.exports = __webpack_public_path__ + "img/rios-tinta.a4d0361b.webp";